import initPinterest from './pinterest';
import initTwitter from './twitter';

export default function initSocialPlugins() {
  return Promise.all([initPinterest(), initTwitter()]);
}
